// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__l37PH","section-1":"styles_section-1__+wR+p","content":"styles_content__O1yhA","section-2":"styles_section-2__EssjX"};